module.exports = __webpack_public_path__ + "img/订货ico.2cb236ab.png";